import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Pagination from 'react-js-pagination';
import reviewsActions from '../../store/actions/reviewsActions';
import userStatisticActions from '../../store/actions/userStatisticActions';
import ReviewItem from '../../components/ReviewInfo/ReviewItem';
import IconLongArrow from '../../components/UI/Icons/IconLongArrow';
import productActions from '../../store/actions/productActions';
import AdvertList from '../../components/AdvertList/AdvertList';
import IconUser from '../../components/UI/Icons/IconUser';
import helpers from '../../helpers/helpers';
import Preloader from "../../components/UI/Preloader";
import CollectionList from "../../components/CollectionList";
import collectionsActions from "../../store/actions/collectionActions";
import ShareBtn from '../../components/ShareBtn/ShareBtn';
import urlHelper from '../../helpers/url.helper';
import MetaTags from '../../components/MetaTags/MetaTags';
import { getUserMetaDescription, getUserMetaTitle } from '../../helpers/getUserMeta';

const ShopInfo = () => {
    const dispatch = useDispatch();

    const {
        userCollections,
        userCollectionsPagination,
        collectionsIsLoading
    } = useSelector((state) => state.collections)

    const {
        userReviewsList,
        userReviewsListPagination,
        reviewsIsLoading,
    } = useSelector((state) => state.reviews);
    const {
        foundProducts,
        foundPagination,
        searchIsLoading,
    } = useSelector((state) => state.products);
    const {
        aboutUser,
        aboutUserData,
        aboutUserLogo,
    } = useSelector((state) => state.statistic);
    const {
        language,
    } = useSelector((state) => state.language);

    const { getTranslationText } = helpers;

    const router = useRouter();
    const { username } = router.query;

    useEffect(() => {
        dispatch(userStatisticActions.getAboutUser(null, username));
        dispatch(collectionsActions.getUserCollections(username));
    }, []);

    useEffect(() => {
        if (aboutUserData?.id) dispatch(reviewsActions.getUserReviews(aboutUserData.id));
    }, [aboutUserData]);

    useEffect(() => {
        const params = {
            search: decodeURIComponent(username),
            searchFields: 'username',
            page: 1,
        };

        dispatch(productActions.getSearchAllProducts(params));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username]);

    const handlePageChangeRew = (page) => {
        const params = {
            page,
        };

        dispatch(reviewsActions.getUserReviews(username, params));
    };

    const handlePageChangeProd = (page) => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });

        const params = {
            search: router.query.username,
            searchFields: 'username',
            page,
        };

        dispatch(productActions.getSearchAllProducts(params));
    };

    const handleTab = (item) => {
        setTab(item);
    }

    const [tab, setTab] = useState(0);

    return (
        <>
            <MetaTags
                metaTitle={getUserMetaTitle(username, language)}
                metaDescription={getUserMetaDescription(username, language)}
            />
            <div className="reviews-page">
                <div className="banner-content">
                    {aboutUserLogo && (
                        <img src={aboutUserLogo} />
                    )}
                </div>
                <ShareBtn
                    modalClassName="reviews-page__share"
                    linkText={`${urlHelper.getBasePath(router)}${router.asPath}`}
                    iframeText={`<iframe src="${urlHelper.getBasePath(router)}/widget/user/${router.query.username}" frameborder="0" width="100%" height="353"></iframe>`}
                />
                {language && (
                    <div className="content-wrapper">
                        <div className="top-about">
                            <div className="profile-data-wrapper">
                                <div className="logo-inner-wrapper">
                                    {aboutUserData?.avatar ?
                                        <img className="logo" src={aboutUserData?.avatar} /> : <IconUser color="#706e7d" />
                                    }
                                </div>
                                <div className="shop-name">{router.asPath.split('/').reverse()[0].split('?').reverse()[0]}</div>
                            </div>
                            <div className="about-shop__title">{getTranslationText('shop.about_shop')}</div>
                            <div className="about-shop__info" dangerouslySetInnerHTML={{ __html: aboutUser }} id="shop__info" />
                        </div>
                        <div className="container container-shop-info">
                            <div className="product__additional">
                                <div className="product__additional__header">
                                    <h3>{getTranslationText('shop.additional_info')}</h3>
                                    <div>
                                        <button
                                            type="button"
                                            className={tab === 0 ? 'active' : ''}
                                            onClick={() => handleTab(0)}
                                        >
                                            {getTranslationText('shop.products')}
                                        </button>
                                        <button
                                            type="button"
                                            className={tab === 1 ? 'active' : ''}
                                            onClick={() => handleTab(1)}
                                        >
                                            {getTranslationText('profile.reviews')}
                                        </button>
                                        <button
                                            type="button"
                                            className={tab === 2 ? 'active' : ''}
                                            onClick={() => setTab(2)}
                                        >
                                            {getTranslationText('profile.collections') || language === 'ru-RU' ? 'Коллекции' : 'Collections'}
                                        </button>
                                    </div>
                                </div>
                                {tab === 0 && (
                                    <div className="product__additional__tab">
                                        <div className="product__additional__tab__container">
                                            <AdvertList
                                                products={foundProducts}
                                                isLoading={searchIsLoading}
                                            />
                                            {foundPagination.total_pages > 1 && (
                                                <Pagination
                                                    activePage={foundPagination.current_page}
                                                    itemsCountPerPage={foundPagination.per_page}
                                                    totalItemsCount={foundPagination.total}
                                                    pageRangeDisplayed={8}
                                                    onChange={handlePageChangeProd}
                                                    hideFirstLastPages
                                                    nextPageText={<IconLongArrow color="#4579f5" />}
                                                    prevPageText={<IconLongArrow color="#4579f5" />}
                                                    itemClassNext="next"
                                                    itemClassPrev="prev"
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                                {tab === 1 && (
                                    <div className="product__additional__tab">
                                        <div className="product__additional__tab__container">
                                            {reviewsIsLoading && <Preloader />}
                                            {userReviewsList.map((item) => (
                                                <ReviewItem
                                                    username={item.user.username}
                                                    rating={item.rating}
                                                    content={item.review}
                                                    date={item.created_at}
                                                />)
                                            )}
                                            {!reviewsIsLoading && !userReviewsList.length &&
                                                <p className="filler">{getTranslationText('reviews.no_reviews_list')}</p>}
                                            {userReviewsListPagination?.current_page
                                                && userReviewsListPagination?.current_page !== 1
                                                && (
                                                    <Pagination
                                                        activePage={userReviewsListPagination.current_page}
                                                        itemsCountPerPage={userReviewsListPagination.per_page}
                                                        totalItemsCount={userReviewsListPagination.total}
                                                        pageRangeDisplayed={8}
                                                        onChange={handlePageChangeRew}
                                                        hideFirstLastPages
                                                        nextPageText={<IconLongArrow color="#4579f5" />}
                                                        prevPageText={<IconLongArrow color="#4579f5" />}
                                                        itemClassNext="next"
                                                        itemClassPrev="prev"
                                                    />
                                                )}
                                        </div>
                                    </div>
                                )}
                                {/*Collections tabs*/}
                                {tab === 2 && (
                                    <div className="product__additional__tab">
                                        <div className="product__additional__tab__container">
                                            {userCollections && (
                                                <CollectionList collections={userCollections} isLoading={collectionsIsLoading} />)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ShopInfo;
